































































































































import { Component, Vue } from 'vue-property-decorator';
import { GetAgeBandByValue, getTicketStatusByValue } from '@/utils/web-redemption';
import moment from 'moment';
import { DateSearchTypeList } from '@/utils/componentHelpers';
import { getArrivalsModule, TicketOrdered } from '@/store/modules/.deprecated/moduleReportArrivals';
import { tablePaginationOptions } from '@/utils/helpers';

@Component
export default class UpcomingArrivalsReport extends Vue {
  /* DATA */

  // modules
  private arrivalModule = getArrivalsModule();

  // dialog appearance
  private dateFromModal = false;
  private dateUntilModal = false;

  // date picker values - OLD todo
  private fromDate = '';
  private untilDate = '';

  // date picker values - NEW todo
  private dateRange = [];
  private datePick = '';
  private dateRangeType = 'dateRange';

  // other
  private search = '';

  private reportHeaders: Array<Record<string, any>> = [
    { text: 'Reseller', align: 'left', sortable: true, value: 'reseller_name' },
    { text: 'Organization', align: 'left', sortable: true, value: 'organization' },
    {
      text: 'Travel Date',
      align: 'left',
      sortable: true,
      value: 'travel_date',
      sort: (a: string, b: string) => (moment(a).isBefore(moment(b)) ? -1 : 1),
    },
    { text: 'Product', align: 'left', sortable: true, value: 'product' },
    { text: 'Guest', align: 'left', sortable: true, value: 'guest' },
    { text: 'Status', align: 'left', sortable: true, value: 'status' },
    { text: 'Reference #', align: 'left', sortable: true, value: 'supplier_reference' },
    { text: 'Booking ID', align: 'left', sortable: true, value: 'booking_id' },
  ];

  private datePickerOptions() {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Normalize to midnight for accurate comparison
    return {
      disabledDate(time: Date) {
        return time.getTime() < today.getTime();
      },
    };
  }

  private dateSearchTypeList = DateSearchTypeList(this.$i18n);

  /* COMPUTED */

  private get Tickets(): any[] {
    return this.arrivalModule.Tickets;
  }

  private get FormattedTickets(): any[] {
    const tickets = [] as Array<any>;
    this.arrivalModule.Tickets.map((t: TicketOrdered) => {
      tickets.push({
        id: t.id,
        reseller_name: t.reseller_name,
        organization: t.supplier_code,
        travel_date: t.travel_date,
        product: this.getProduct(t),
        guest: this.buildTravelerInfo(t),
        status: this.ticketStatus(t),
        supplier_reference: t.supplier_ref,
        booking_id: t.booking_id,
      });
    });
    return tickets;
  }

  private get ItemsPerPage() {
    return 10;
  }

  private get Loading(): boolean {
    return this.arrivalModule.nested.Loading;
  }

  get paginationOptions() {
    return tablePaginationOptions(this.Tickets);
  }

  /* HOOKS */
  async created() {
    this.arrivalModule.clearState();
  }

  destroyed() {
    this.arrivalModule.clearState();
  }

  /* METHODS */

  // event handlers

  private async changeDates(which: string) {
    try {
      this.dateFromModal = false;
      this.dateUntilModal = false;

      const dateRange: {
        fromDate?: moment.Moment | null;
        untilDate?: moment.Moment | null;
      } = {};

      if (which === 'from') {
        dateRange.fromDate = this.fromDate ? moment(this.fromDate) : null;
        this.fromDate = '';
      } else if (which === 'until') {
        dateRange.untilDate = this.untilDate ? moment(this.untilDate) : null;
        this.untilDate = '';
        // NEW - start
      } else if (which === 'range') {
        if (!this.dateRange) return;
        dateRange.fromDate = this.dateRange[0] ? moment(this.dateRange[0]) : null;
        dateRange.untilDate = this.dateRange[1] ? moment(this.dateRange[1]) : null;
      } else if (which === 'dateSelect') {
        if (this.dateRangeType === 'fromDate') {
          dateRange.fromDate = this.datePick ? moment(this.datePick) : null;
          dateRange.untilDate = null;
        } else if (this.dateRangeType === 'untilDate') {
          dateRange.untilDate = this.datePick ? moment(this.datePick) : null;
          dateRange.fromDate = moment();
        }
        // NEW - end
      }

      await this.arrivalModule.changeDates({ range: dateRange });
    } catch {
      // send alert to backend
    }
  }

  private clearValues() {
    this.dateRange = [];
    this.datePick = '';
  }

  private refresh() {
    this.arrivalModule.searchTickets().catch(() => {
      // todo send alert to backend
    });
  }

  // template helpers

  private ticketStatus(ticket: any) {
    try {
      return getTicketStatusByValue(ticket.status);
    } catch {
      return '';
    }
  }

  private buildTravelerInfo(item: any): string {
    if (!item.travelers || !item.travelers.length) return '';
    const traveler = item.travelers[0];
    return [
      `Name: ${traveler.full_name || ''}`,
      `Email: ${traveler.email || ''}`,
      `Phone: ${traveler.mobile || ''}`,
      `Age: ${GetAgeBandByValue(traveler.age_band)}`,
    ].join('\n');
  }

  private getProduct(ticket: any) {
    if (!ticket.products || !ticket.products.length) return '';
    return ticket.products[0].title;
  }

  private copy(id: string) {
    navigator.clipboard.writeText(id);
  }
}
